/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".memo-bookmark[_ngcontent-%COMP%]{position:absolute;top:-.2rem;right:25%;color:var(--component-title-background-color);font-size:2rem}.offer-pair-id[_ngcontent-%COMP%]{padding:1rem;font-size:1rem;color:var(--text-color)}"];
export { styles as styles };
